import { render, staticRenderFns } from "./removeSubject.vue?vue&type=template&id=53a8c720&scoped=true&"
import script from "./removeSubject.vue?vue&type=script&lang=js&"
export * from "./removeSubject.vue?vue&type=script&lang=js&"
import style0 from "./removeSubject.vue?vue&type=style&index=0&id=53a8c720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a8c720",
  null
  
)

export default component.exports